<template>
  <div>
    <el-alert
      title="盘点和重包装过账都会写入流水。本租户第一次打开时，历史回放含已过账的盘点和重包装。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.materialCode" clearable placeholder="产品编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.materialName" clearable placeholder="产品名称" style="width:140px" @keyup.enter.native="search" />
      <el-select v-model="query.wareHouseId" clearable filterable placeholder="仓库" style="width:160px">
        <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
      </el-select>
      <el-select v-model="query.bizGroup" clearable placeholder="业务类型" style="width:130px">
        <el-option v-for="item in bizOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="bizTime" label="变动时间" width="170" />
      <el-table-column prop="bizName" label="业务类型" width="120" />
      <el-table-column prop="sourceCode" label="单据号" width="160" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="产品编码" width="130" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="wareHouseName" label="仓库" width="120" show-overflow-tooltip />
      <el-table-column prop="wareAreaName" label="库位" width="110" show-overflow-tooltip />
      <el-table-column prop="batchNo" label="批次" width="120" show-overflow-tooltip />
      <el-table-column prop="palletCode" label="托盘" width="110" show-overflow-tooltip />
      <el-table-column label="变动数量" width="110" align="right">
        <template slot-scope="{ row }">
          <span :style="{ color: changeColor(row.changeQty) }">{{ formatChange(row.changeQty) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="balanceQty" label="结存数量" width="110" align="right" />
      <el-table-column prop="unitName" label="单位" width="70" align="center" />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listStockLedger } from '../../api/stockLedger'
import { selectEnabledWareHouse } from '../../api/warehouse'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { materialCode: '', materialName: '', wareHouseId: '', bizGroup: '' },
      dateRange: null,
      list: [], total: 0, page: 1, pageSize: 20, loading: false, warehouses: [],
      bizOptions: [
        { label: '领料', value: 'ISSUE' },
        { label: '退料', value: 'RETURN' },
        { label: '移库', value: 'TRANSFER' },
        { label: '生产入库', value: 'PROD_IN' },
        { label: '发货出库', value: 'SHIP' },
        { label: '采购入库', value: 'PURCHASE_IN' },
        { label: '其他入库', value: 'OTHER_IN' },
        { label: '其他出库', value: 'OTHER_OUT' },
        { label: '盘点', value: 'STOCKTAKING' },
        { label: '重包装', value: 'REPACK' },
        { label: '结存校正', value: 'ADJUST' }
      ]
    }
  },
  created() {
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      const range = this.dateRange || []
      listStockLedger({
        currentPage: this.page, pageSize: this.pageSize,
        materialCode: this.query.materialCode, materialName: this.query.materialName,
        wareHouseId: this.query.wareHouseId, bizGroup: this.query.bizGroup,
        bizTimeStart: range[0], bizTimeEnd: range[1]
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    formatChange(qty) {
      if (qty === null || qty === undefined || qty === '') return ''
      const n = Number(qty)
      if (Number.isNaN(n)) return qty
      return n > 0 ? '+' + qty : String(qty)
    },
    changeColor(qty) {
      const n = Number(qty)
      if (Number.isNaN(n) || n === 0) return ''
      return n > 0 ? '#67C23A' : '#F56C6C'
    }
  }
}
</script>
